<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Innovacio')"></BreadcrumSection>

    <h1>{{ $t("Innovacio") }}</h1>

    <MaterialsCommon init-query="activitat_subtipus:innovacio" router-name="materials"></MaterialsCommon>

  </div>

</template>

<script>

import store from "@/store";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {setMetadata} from "@/composables/metadataFunctions";
import MaterialsCommon from "@/components/MaterialsCommon.vue";
import {onActivated, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";

export default {
  name: "InnovacioView",
  components: {
    MaterialsCommon,
    BreadcrumSection
  },

  setup(){
    const route = useRoute();
    const { t } = useI18n();
    const isDataLoaded = ref(false);

    onMounted(async () => {
      setMetadata(t('Materials'))
      await store.dispatch('updateSearchSelected', "Materials");
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-xarxa.webp') });
      isDataLoaded.value = true
    });


    onActivated(() => {
      if (!isDataLoaded.value) {
        // Data loading logic
      }
    });

    return{
    }
  }
}

</script>

<style scoped>
</style>
